'use strict';

const { h, render } = require('phy');
const SelectWidgetDesktopContainer = require('../containers/select_widget_desktop_container');

const renderWidget = {
  init({ selectWidget }, done) {
    if (!selectWidget || selectWidget.props.touchRequest) {
      done();
    }

    const container = document.querySelector('#select-widget-container');

    return render(
      h(SelectWidgetDesktopContainer, selectWidget.props),
      container,
      container.lastChild
    );
  },
};

module.exports = renderWidget;
